// helpers/checkDataBuilder.js

import { helps } from 'src/_helpers';


export const buildChecksData = ({
    projects = [],
    employees = [],
    positions = [],
    checks = [],
    curent_date
}) => {

    const employeeMap = {};

    const positionMap = {};

    const positionsByProject = {};

    const positionsByArea = {};

    const checksByEmployee = {};

    const checksByProject = {};

    const activeProjects = [];



    /*
    |--------------------------------------------------------------------------
    | Current Date
    |--------------------------------------------------------------------------
    */

    const currentDate =
        new Date(curent_date);

    const currentDateKey =
        `${currentDate.getFullYear()}-${currentDate.getMonth()
        }-${currentDate.getDate()
        }`;

    /*
    |--------------------------------------------------------------------------
    | Employees Map
    |--------------------------------------------------------------------------
    */

    employees.forEach(employee => {

        employeeMap[
            employee.employee_id
        ] = employee;
    });

    /*
    |--------------------------------------------------------------------------
    | Positions Map
    |--------------------------------------------------------------------------
    */

    positions.forEach(position => {

        positionMap[
            position.id
        ] = position;

        /*
        | positionsByProject
        */

        if (
            !positionsByProject[
            position.project_id
            ]
        ) {

            positionsByProject[
                position.project_id
            ] = [];
        }

        positionsByProject[
            position.project_id
        ].push(position);

        /*
        | positionsByArea
        */

        if (position.area_id) {

            if (
                !positionsByArea[
                position.area_id
                ]
            ) {

                positionsByArea[
                    position.area_id
                ] = [];
            }

            positionsByArea[
                position.area_id
            ].push(position);
        }
    });

    /*
    |--------------------------------------------------------------------------
    | Checks
    |--------------------------------------------------------------------------
    */

    checks.forEach(check => {

        const checkDate =
            new Date(
                check.check_date
            );

        const checkDateKey =
            `${checkDate.getFullYear()}-${checkDate.getMonth()
            }-${checkDate.getDate()
            }`;

        /*
        | Chỉ lấy ngày hiện tại
        */

        if (
            checkDateKey !==
            currentDateKey
        ) {
            return;
        }

        /*
        | employee map
        */

        const employee =
            employeeMap[
            check.employee_id
            ];

        /*
        | position map
        */

        let position = {};

        if (
            check.position &&
            check.position.id
        ) {

            position =
                positionMap[
                check.position.id
                ] ||
                check.position;

        }
        else if (
            check.position_id
        ) {

            position =
                positionMap[
                check.position_id
                ] || {};
        }

        const normalizedCheck = {

            ...check,

            employee,

            position
        };

        /*
        | checksByEmployee
        */

        if (
            !checksByEmployee[
            check.employee_id
            ]
        ) {

            checksByEmployee[
                check.employee_id
            ] = [];
        }

        checksByEmployee[
            check.employee_id
        ].push(
            normalizedCheck
        );

        /*
        | checksByProject
        */

        const projectId =
            position.project_id ||
            check.project_id;

        if (projectId) {

            if (
                !checksByProject[
                projectId
                ]
            ) {

                checksByProject[
                    projectId
                ] = [];
            }

            checksByProject[
                projectId
            ].push(
                normalizedCheck
            );
        }
    });

    /*
    |--------------------------------------------------------------------------
    | Sort checks
    |--------------------------------------------------------------------------
    */

    Object.keys(
        checksByEmployee
    ).forEach(employeeId => {

        checksByEmployee[
            employeeId
        ].sort(
            (a, b) =>
                b.checkin_time -
                a.checkin_time
        );
    });

    Object.keys(
        checksByProject
    ).forEach(projectId => {

        checksByProject[
            projectId
        ].sort(
            (a, b) =>
                b.checkin_time -
                a.checkin_time
        );
    });

    /*
    |--------------------------------------------------------------------------
    | Active Projects
    |--------------------------------------------------------------------------
    */

    projects.forEach(project => {

        if (
            project.active === 1
        ) {

            const projectEmployees =
                !helps.isEmpty(
                    project.employees
                )
                    ? project.employees.map(
                        item => {

                            const employee =
                                employeeMap[
                                item.employee_id
                                ];

                            const position =
                                positionMap[
                                item.position_id
                                ];

                            const employeeChecks =
                                (
                                    checksByEmployee[
                                    item.employee_id
                                    ] || []
                                ).filter(check => {

                                    const projectId =
                                        check.position?.project_id ||
                                        check.project_id;

                                    return (
                                        projectId === project.id
                                    );
                                });

                            const defaultShift =
                                position &&
                                    position.shifts
                                    ? position.shifts.find(
                                        shift =>
                                            shift.id ===
                                            item.shift_id
                                    )
                                    : null;

                            return {

                                ...item,

                                employee,

                                position,

                                default_shift:
                                    defaultShift,

                                checks:
                                    employeeChecks
                            };
                        }
                    )
                    : [];

            activeProjects.push({

                ...project,

                positions:
                    positionsByProject[
                    project.id
                    ] || [],

                employees:
                    projectEmployees,

                projectChecks:
                    checksByProject[
                    project.id
                    ] || []
            });
        }
    });

    /*
    |--------------------------------------------------------------------------
    | Return
    |--------------------------------------------------------------------------
    */

    return {

        activeProjects,

        employeeMap,

        positionMap,

        positionsByProject,

        positionsByArea,

        checksByEmployee,

        checksByProject
    };
};

/*
|--------------------------------------------------------------------------
| Filter theo Area
|--------------------------------------------------------------------------
*/

export const filterProjectByArea = (
    project,
    selectedAreaId,
    positionsByArea
) => {

    if (!selectedAreaId) {

        return {
            projectChecks:
                project.projectChecks,

            employees:
                project.employees
        };
    }

    const areaPositions =
        positionsByArea[
        selectedAreaId
        ] || [];

    const areaPositionIds =
        new Set(
            areaPositions.map(
                item => item.id
            )
        );

    const employees =
        project.employees.filter(
            employee =>
                areaPositionIds.has(
                    employee.position_id
                )
        );

    const projectChecks =
        project.projectChecks.filter(
            check =>
                areaPositionIds.has(
                    check.position?.id
                )
        );

    return {
        employees,
        projectChecks
    };
};

/*
|--------------------------------------------------------------------------
| Total Duration
|--------------------------------------------------------------------------
*/
export const calculateTotalDuration =
    (
        employees = [],
        projectChecks = []
    ) => {

        let total = 0;

        const processed =
            new Set();

        employees.forEach(employee => {

            (
                employee.checks || []
            ).forEach(check => {

                if (
                    processed.has(check.id)
                ) {
                    return;
                }

                processed.add(
                    check.id
                );

                total +=
                    Number(
                        check.check_duration
                    ) || 0;
            });
        });

        projectChecks.forEach(check => {

            if (
                processed.has(check.id)
            ) {
                return;
            }

            processed.add(
                check.id
            );

            total +=
                Number(
                    check.check_duration
                ) || 0;
        });

        return total;
    };